import {defaults, get} from "axios";

defaults.headers.common['Accept'] = 'application/json';
defaults.headers.post['Content-Type'] = 'application/json';


/**
 * Get User Interest List from User DB
 * @param {*} token 
 */
export function getInterestList(token){
    return new Promise((resolve, reject) => {
        let url = `${process.env.API_BASE_URL}user/interest`,
            config = {
                headers: {
                    auth_token: token,
                }
            };

        get(url, config)
            .then(res => {
                if(res.status === 200){
                    resolve(res.data)
                }
            })
            .catch((error) => {
                reject(error.response)
            })
    })
}



/**
 * Get All category Lists from Matcha Media Site DB
 * @param {*} param 
 */
export function getCategoryLists(param) {
    return new Promise((resolve, reject) => {
        let url = `${process.env.API_BASE_URL}misc?token=${process.env.UNIQUE_TOKEN}&lang_id=${param.lang_id}&function_type=category_list`

        get(url)
            .then(response => {
                var datas = response.data.data;
                // For remove exchanged category id, which are reflected same name twice
                response.data.data = datas.filter( (value, index, arr) => {
                    return [70, 72, 76, 77, 78].indexOf(value.category_id) === -1;
                });

                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
  

/**
 * Get Articles list Based on user Interest
 * @param {*} interest 
 * @param {*} args 
 */
export function getInterestBasedArticles(interest, args){
    return new Promise((resolve, reject) => {
        let url = 'https://app-api.matcha-jp.com/api/com/categoriesdata/',
            params = {
                token: process.env.UNIQUE_TOKEN,
                lang_id: args.lang_id,
                type: 'latest',
                page: args.page,
                category_ids: interest.join(),
                data_limit:args.limit || 12
            };

        get(url, {params})
            .then(res => {
                if(res.data.length > 0){
                    resolve(res.data.data)
                }else{
                    resolve(res.data)
                }
            })
            .catch(err => {
                resolve(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/api/user-interest.js